import { UseCreateBanner, useEditBanner } from '../../../../Query/BannerQuery';

type OnSubmitParams = {
  bannerData?: any;
  onCancel: () => void;
};

export const useBannerFormSubmit = ({
  bannerData,
  onCancel,
}: OnSubmitParams) => {
  const { mutate: EditBanner, isPending: EditBannerLoading } = useEditBanner();
  const { mutate: createBanner, isPending: createBannerLoading } =
    UseCreateBanner();

  const onSubmit = async (values: any) => {
    const modifiedValues = { ...values };
    try {
      if (bannerData) {
        EditBanner(
          {
            id: String(bannerData.id || ''),
            data: modifiedValues,
          },
          {
            onSuccess: () => {
              onCancel();
            },
            onError: (error: any) => {
              console.error(error);
            },
          }
        );
      } else {
        createBanner(modifiedValues, {
          onSuccess: () => {
            onCancel();
          },
          onError: (error: any) => {
            console.error(error);
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { onSubmit, EditBannerLoading, createBannerLoading };
};
